// extracted by mini-css-extract-plugin
module.exports = {"openingNews":"openingNews-module--openingNews--1XaZ2","content":"openingNews-module--content--3mJVG","title":"openingNews-module--title--3EV6r"};